module.exports = __webpack_public_path__ + "static/assets/ec8dc74d744d234e07ebee11865b6246.svg";